<template>
  <section class="section-menu" id="menus">
    <h2 class="section-menu__title" v-reveal>{{ section.title }}</h2>

    <div class="section-menu__section" v-for="(menu, key) in menus">
      <template v-if="!menu.pdf">
        <div class="section-menu__section-title" v-reveal>
          <h3 class="section-menu__section-title-text">{{ menu.title }}</h3>
        </div>

        <p class="section-menu__description" v-reveal v-if="menu.description">
          {{ menu.description }}
        </p>

        <template v-if="menu.extra">
          <div class="section-menu__extras" v-reveal>
            <div class="section-menu__section-items">
              <div
                class="section-menu__section-item -half"
                v-for="i in menu.meals"
                :key="i.flexKey"
              >
                <b v-reveal>{{ i.name }} {{ i.price }}</b>
                <p v-reveal>{{ i.description }}</p>
              </div>
            </div>

            <div class="section-menu__section-item section-menu__extra">
              <div class="section-menu__extra-bold">+ + + +</div>
              <div class="section-menu__extra-subtitle">{{ menu.extra.title }}</div>
              <ul>
                <li
                  v-reveal
                  v-for="item in menu.extra.items"
                  :key="item.flexKey"
                  class="section-menu__extra-text"
                >
                  {{ item.name }} {{ item.price }}
                </li>
              </ul>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="section-menu__section-items">
            <div class="section-menu__section-item" v-for="i in menu.meals" :key="i.flexKey">
              <b v-reveal>{{ i.name }} {{ i.price }}</b>
              <p v-reveal>{{ i.description }}</p>
            </div>
          </div>
        </template>
      </template>

      <template v-else>
        <SectionImage
          v-reveal
          :gallery="false"
          :images="[menu.image]"
          white
          :button="{ label: menu.pdf?.label, link: menu.pdf.file.original }"
          :text="menu.description"
          :title="menu.title"
          style="color: black"
        />
      </template>
    </div>
  </section>
</template>

<script>
import SectionImage from '@/components/SectionImage.vue'
export default {
  name: 'SectionMenus',
  components: {
    SectionImage,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  computed: {
    menus() {
      return Object.values(this.$beet.menus).toSorted((a, b) => {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
      })
    },
  },
  methods: {
    openDrinkMenu(link) {
      window.open(link, '_blank')
    },
  },
}
</script>
